import axios from "axios";
import { authEndpoint } from "../../../routes/api_endpoints";
/**
 * @typedef {Object} LoginResponse
 * @property {userDetails} user
 * @property {boolean} success
 */
/**
 * @typedef {Object} userDetails
 * @property {string} FullName
 */
/**Logs in a user then returns their details
 * @return {Promise<LoginResponse>}
 */
const loginPromise = (phone, otp) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        `${authEndpoint}/login`,
        {
          phone: phone,
          otp: otp,
        },
        { withCredentials: true }
      )
      .then((response) => {
        /**@type {LoginResponse} */
        let data = {
          success: response.data.success,
          user: response.data.success ? response.data.data : null,
        };
        resolve(data);
      })
      .catch((error) => reject(error));
  });

export default loginPromise;
